(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-dom"), require("react-router-dom"), require("@monza/toolkit"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "react-dom", "react-router-dom", "@monza/toolkit"], factory);
	else if(typeof exports === 'object')
		exports["components"] = factory(require("react"), require("react-dom"), require("react-router-dom"), require("@monza/toolkit"));
	else
		root["components"] = factory(root["react"], root["react-dom"], root["react-router-dom"], root["@monza/toolkit"]);
})(Object(typeof self !== 'undefined' ? self : this), (__WEBPACK_EXTERNAL_MODULE__155__, __WEBPACK_EXTERNAL_MODULE__514__, __WEBPACK_EXTERNAL_MODULE__61__, __WEBPACK_EXTERNAL_MODULE__158__) => {
return 